import React, { useState, useEffect } from 'react';

// material-ui
import {
    Box,
    Grid,
    Typography,
    Button,
    Dialog
} from "@mui/material";
import { TCInput } from 'components/TopCourtComponents/Input/TopCourtInput';
import { createCategory, updateCategory, deleteCategory } from 'services/categoryServices';
import { toast } from 'react-toastify';
import { cleanNumber, formatThousandSeparatorString } from 'helper/NumberFormat';
import ButtonComponent from 'views/components/buttonComponent';
import BoxButtonComponent from 'views/components/boxButtonComponent';
import ConfirmDialogComponent from 'views/components/cofirmDialogComponent';
import { validation } from 'helper/Form';
import { createMerchantCategory } from 'services/merchantServices';
import { IconTrash } from '@tabler/icons';

export default function AddAddOnCategoryDialog({ merchantId, placeId, setDialog, handleClose }) {
    const [isSaving, setIsSaving] = useState(false)
    const [isDeleting, setIsDeleting]  = useState(false)
    const [confirmOpen, setConfirmOpen] = useState(false)

    const [form, setForm] = useState({
        name: '',
        defaultPrice: '',
    });

    const [joi, setJOI] = useState({
            name: "required",
            defaultPrice: "required"
    })
    
    useEffect(() => {
        setJOI(prev => ({
            name: !validation.isNotEmpty(form.name) ? "Required" : "",
            defaultPrice: !validation.isNotEmpty(form.defaultPrice) ? "Required" : "",
        }))
    }, [form])
    
    const createOrUpdate = () => {
        setIsSaving(true);
        form.defaultPrice = cleanNumber(form.defaultPrice);
        if (form._id) {
            update()
        } else {
            create()
        }
    }

    const create = async () => {
        try {
            let body = { ...form, merchantId: merchantId, placeId: placeId}
            let { data, error } = await createCategory(body);
            if (error) throw error;
            if (data) {
                toast.success('AddOn Category created successfully');
                handleClose();
                setIsSaving(false);
                clearForm();
            }
        } catch (error) {
            setIsSaving(false);
            console.log(error);
        }
    }

    const update = async () => {
        try {
            let { data, error } = await updateCategory(form);
            if (error) throw error;
            if (data) {
                toast.success('AddOn Category updated successfully');
                handleClose();
                setIsSaving(false);
            }
        } catch (error) {
            setIsSaving(false);
            console.log(error);
        }
    }

    const deleteData = async (id) => {
        try {
            setIsDeleting(true);
            const { data, error } = await deleteCategory(id);
            if (error) throw error;

            toast.success('AddOn Category deleted successfully');
            handleClose(); // misal menutup modal form atau refresh list
        } catch (err) {
            toast.error("Failed to delete");
            console.error(err);
        } finally {
            setIsDeleting(false);
        }
    };


    const handleDelete = () => {
        setConfirmOpen(true); // munculkan dialog konfirmasi
    };

    const handleConfirmDelete = async () => {
        await deleteData(form._id);
        setConfirmOpen(false); // tutup dialog
    };      

    const clearForm = async () => {
        setForm({
            name: '',
            defaultPrice: ''
        })
    }

    useEffect(() => {
        clearForm()
        if (setDialog.data) {
            let defaultPrice = formatThousandSeparatorString(setDialog.data.defaultPrice);
            setForm({
                _id: setDialog.data._id,
                name: setDialog.data.name,
                defaultPrice: defaultPrice,
            });
        }
    }, [setDialog.data]);

    return (
        <>
        <ConfirmDialogComponent
            open={confirmOpen}
            onCancel={() => setConfirmOpen(false)}
            onConfirm={handleConfirmDelete}
            loading={isDeleting}
            title="Delete Confirmation"
            content="Are you sure you want to delete this category?"
            confirmLabel="Delete"
            cancelLabel="Cancel"
            loadingConfirmLabel="Deleting..."
        />
            <Dialog open={setDialog.open} onClose={handleClose}>
                <Box sx={{ padding: 2, width: 'auto', maxWidth: 370 }}>
                    <Typography variant="h6" gutterBottom>
                        {!form._id ? 'Add' : 'Update'} Category
                    </Typography>
                    <Box component="form" noValidate autoComplete="off">
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={12}>
                                <TCInput
                                    fullWidth
                                    label="Category Name*"
                                    value={form.name}
                                    onChange={(e) => setForm({ ...form, name: e.target.value })}
                                    showAlert={joi.name}
                                />
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <TCInput
                                    fullWidth
                                    label="Default Price*"
                                    value={form.defaultPrice}
                                    onChange={(e) => setForm({ ...form, defaultPrice: e.target.value })}
                                    isThousandSeparator="true"
                                    showAlert={joi.defaultPrice}
                                />
                            </Grid>
                        </Grid>

                        <BoxButtonComponent justify={form?._id ? 'space-between' : 'flex-end'} direction="row">
                            {form?._id && (
                                <Button size="small" sx={{ minWidth: 0 }} color="error" onClick={() => handleDelete()}>
                                    <IconTrash/>
                                </Button>
                            )}
                            <Box display="flex" gap={1}>
                                <Button variant="outlined" color="secondary" onClick={handleClose}>
                                    Cancel
                                </Button>
                                <ButtonComponent
                                    disabled={!(form.name && form.defaultPrice)}
                                    onClick={() => createOrUpdate()}
                                    loading={isSaving}
                                    label="Save"
                                    loadingLabel="Saving..."
                                />
                            </Box>
                        </BoxButtonComponent>
                    </Box>
                </Box>
            </Dialog>
        </>
    )
}